
/**
 * Check if the provided step has the same name as the special cases step name provided
 *
 * @param {object} step The step to evaluate
 * @param {object} specialCases Special cases object in state
 * @param {string} name The key on the `specialCases.stepNames` object to use
 */
export function isStepOfType(step, specialCases, name) {
  if (!step || !specialCases) {
    return false;
  }
  return step && step.name === specialCases.stepNames[name];
}

/**
 * Short-hand version of `isStepOfType` asserting the name is 'size'
 * @param {object} step The step to evaluate
 * @param {object} specialCases Special cases object in state
 */
export function isSizeStep(step, specialCases) {
  return isStepOfType(step, specialCases, 'size');
}

/**
 * Get the item object for the step that is currently selected
 * @param {object} step The step to evaluate
 */
export function getSelectedStepItem(step) {
  if (step && Array.isArray(step.sections)) {
    const section = step.sections.find(({ selected }) => selected);
    if (section && Array.isArray(section.categories)) {
      const category = section.categories.find(({ selected }) => selected);
      if (category && Array.isArray(category.items)) {
        return category.items.find(({ selected }) => selected);
      }
    }
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/helpers/step.js